import React, {useMemo} from 'react';
import Select from 'react-select';

export const sortBy = (key) => ((a, b) => {
    const defaultValue = key === 'order' ? 9999 : '';
    let aVal = a[key] ?? defaultValue;
    let bVal = b[key] ?? defaultValue;

    // If both are numbers, compare numerically
    if (typeof aVal === 'number' && typeof bVal === 'number') {
        return aVal - bVal;
    }

    // If both are strings, compare case-insensitively
    if (typeof aVal === 'string' && typeof bVal === 'string') {
        aVal = aVal.toLowerCase();
        bVal = bVal.toLowerCase();
        if (aVal < bVal) return -1;
        if (aVal > bVal) return 1;
        return 0;
    }

    // If types differ, convert both to string and compare case-insensitively
    aVal = String(aVal).toLowerCase();
    bVal = String(bVal).toLowerCase();
    if (aVal < bVal) return -1;
    if (aVal > bVal) return 1;
    return 0;
});

export default function Dropdown({options, value, onChange, isMulti, sortFunc, name, optionKey, className, ...props}) {
    const opts = useMemo(() => {
        if (!options || !Array.isArray(options)) return [];
        const sOpts = sortFunc ? options.toSorted(sortFunc) : options;
        return sOpts.map(opt => {
            if (typeof opt === 'string') {
                return {value: opt, label: opt};
            } else if (!opt) {
                return {value: opt, label: ''};
            } else {
                const v = optionKey ? opt[optionKey] : (opt.value ?? opt[name])
                const l = opt.label ?? opt.description ?? v
                if (v === undefined) throw new Error('Option missing value: '+JSON.stringify(opt));
                return {value: v, label: l};
            }
        })
    }, [options]);

    const val = useMemo(() => {
        if (isMulti) {
            if (!value || !Array.isArray(value)) return [];
            return opts.filter(o => value.includes(o.value));
        } else {
            return opts.find(o => o.value==value) || null;
        }
    }, [value, opts, isMulti]);

    const handleChange = (selected) => {
        if (isMulti) {
            onChange({[name]: selected ? selected.map(s => s.value) : []});
        } else {
            onChange({[name]: selected ? selected.value : null});
        }
    }

    return (
        <Select
            className={'dlg-dropdown' + (className? ' '+className : '')}
            name={name}
            options={opts}
            value={val}
            onChange={handleChange}
            isMulti={isMulti}
            {...props}
        />
    )
}
